<template>
<el-card :class="$style.myelcard" shadow="hover">
	<div class="dflex fw500">
	    <div class="f1">
	        <div :class="$style.pic">
	            <!-- <img :src="item['head_portrait']" alt="" class="button" :class="$style.img" @click="onDetailClick"> -->
				<img v-show="videoId != ''" :class="$style.playerButton" src="../assets/youtube.png"  @click="playYoutubeVideo" >
				<img :src="item['head_portrait']" alt=""  :class="$style.img">
	        </div>
	        <div class="fs1 gray" :class="$style.lb">
	            <div class="dflex":class="[$style.fs,$style.cardmore]">
	                <el-checkbox :key="item['code']" :label="item['code']" >{{ $t('select') }}</el-checkbox>
	                <span class="f1 right"><el-link type="primary" @click="onDetailClick">{{$t('more')}}>></el-link></span>
	            </div>
	            <div class="dflex" :class="[$style.fs,$style.cardmore]">
	                <span style="margin-left: 28px;font-size: 16px;">{{$t('status')}}</span>
	                <span class="f1"></span>
	                <span 
	                    :class="$style.state" 
	                    :notavail="!item['available_status']" 
	                    class="white fs14" 
	                    style="padding: 0px 10px;border-radius: 5px;">
	                        {{!!item['available_status'] ? $t('available') : $t('notavailable')}}
	                </span>
	            </div>
	        </div>
	    </div>
	    <div :class="$style.right">
	        <p v-for="item in list" :key="item.label" class="dflex" style="margin-bottom: 0.5rem;">
	            <span class="f1 gray">{{item.label}}</span><span class="gray">:</span>
	            <span :class="$style.value">{{item.value}}</span>
	        </p>
	    </div>
	</div>
	<div>
		<div >
			<div class="dflex" style="margin: 10px;justify-content: center;">
			    <!-- <span class="f1"></span> -->
			    <el-button :class="$style.btcolor"  round @click="onClickRemove">{{ $t('remove') }}</el-button>
				<el-button class="showInLargeb" type="warning" round @click="onClickConfirm">{{ $t('confirmInterview') }}</el-button>
				<el-button class="showInSmall" type="warning" round @click="onClickConfirmInSmall">{{ $t('confirmInterview') }}</el-button>
			</div>
		</div>
		<!-- <div class="showInSmall">
			<div class="dflex" style="margin: 10px;">
			    <span class="f1"></span>
			    <el-button :class="$style.btcolor"  round @click="onClickRemove">Remove</el-button>
			</div>
			<div class="dflex" style="margin: 10px;">
			    <span class="f1"></span>
			    <el-button class="showInLargeb" type="warning" round @click="onClickConfirm">{{ $t('confirmInterview') }}</el-button>
				<el-button class="showInSmall" type="warning" round @click="onClickConfirmInSmall">{{ $t('confirmInterview') }}</el-button>
			</div>
		</div> -->
	</div>
</el-card>	
</template>
<script>


export default {
    name: 'Card',
    props: {
        item: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            videoId:this.item['youtube_video_id'],
        }
    },
    computed: {
        list() {
            return [
                {label: this.$t('code'), value: this.item.code},
                {label: this.$t('name1'), value: this.item.name},
                {label: this.$t('age'), value: this.item.age},
                {label: this.$t('birth'), value: this.item.birthday},
                // {label: this.$t('constellation'), value: this.item.constellation || ''},
                {label: this.$t('zodiac'), value: this.item.zodiac},
                {label: this.$t('marriage'), value: this.item.marriage},
                {label: this.$t('kids'), value: this.item.kids},
                // {label: this.$t('st1'), value: this.item['first_love']},
                // {label: this.$t('st2'), value: this.item['second_love']},
                // {label: this.$t('st3'), value: this.item['third_love']},
                {label: this.$t('religion'), value: this.item['religion']},
            ];
        },
    },
    inject:["loadlist"],
    methods: {
		playYoutubeVideo(){
			this.$emit('setYoutubeVideoId',this.videoId)
		},
        onDetailClick() {
            this.$router.push('/detail/' + this.item.code);
			// let  toTaskLog = this.$router.resolve({path: '/detail/' + this.item.code});
			// window.open(toTaskLog.href,'_blank');
        },
        onClickRemove(){
            this.$service.markInterview({code: this.item.code}).then(() => {
                // this.$set(this.item, 'is_favorite', !this.item['is_favorite']);
                this.$forceUpdate();
				this.loadlist();
            });
        },
		onClickConfirm(){
			this.$service.interviewSetConfirmInfo({code: this.item.code}).then(()=>{
				let  toTaskLog = this.$router.resolve({path: '/newpayment'});
				window.open(toTaskLog.href,'_blank');
			}).catch((res = {}) => {
				this.$message({
				  message: res.message || 'something error',
				  type: 'error',
				  offset: 350,
				});
			});
		},
		onClickConfirmInSmall(){
			this.$service.interviewSetConfirmInfo({code: this.item.code}).then(()=>{
				this.$router.push('/newpayment');
			}).catch((res = {}) => {
				this.$message({
				  message: res.message || 'something error',
				  type: 'error',
				  offset: 350,
				});
			});
		},
    }
}
</script>
<style module>
.myelcard {
	width: 790px !important;
}

.btcolor {
    background-color: #778899 !important;
	color: #fff !important;
}
.state {
    background: #29bd7a;
}
.state[notavail] {
    background: #ec2626;
}
.playerButton {
	width: 2.5rem;
	height: 2.5rem;
	position: absolute;
	left: 10px;
	bottom: 10px;
	cursor: pointer;
}
.pic {
    width:200px;
    height:260px;
	position: relative;
}
.cardmore {
	margin: 8px 0px 5px;
}
.right {
    font-size: 18px;
    line-height: 1.5;
    flex:1.5;
    padding-left: 20px;
    margin-right: 50px;
}
.value {
    flex: 1.5;
    padding-left: 10px;
}
.lb {
    width: 200px;
}
.heart {
    vertical-align: -3px;
    width:18px;
}
.img {
    width: 200px;
    height: 260px;
}
@media screen and (max-width: 770px) {
    .pic {
        width:150px;
        height:200px;
		margin-bottom: 25px;
    }
	.cardmore {
		margin: 15px 0px;
	}
    .img {
        width: 150px;
        height:200px;
    }
    .right {
        font-size: 14px;
        flex:1.5;
        padding-left: 10px;
        margin-right: 0px;
    }
    .value {
        flex: 1;
    }
    .lb {
        width: 150px;
    }
    .fs {
        font-size: 12px;
    }
}
</style>
